import * as _ from "lodash";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SearchFilterModel } from "@app/core/models/search-filter.model";
import { SessionStorageService } from "@app/core/services/session-storage.service";
import { ActivityService } from "@app/core/services/activity.service";
import { FileDownloadService } from "@app/core/services/filedownload.service";
import { ModalHelper } from "@app/shared/models/modal-helper.model";
import { ModalComponent } from "@app/shared/components/modal/modal.component";

@Component({
    selector: 'app-export-invoices-activity',
    templateUrl: './export-invoices-activity.component.html',
    styleUrls: ['./export-invoices-activity.component.scss']
})
export class ExportInvoicesActivityComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<boolean> = new Subject<boolean>();
    panelOpenState: boolean;
    filterStorageKey: string;

    fromFilterDate: string;
    toFilterDate: string;
    title : string;

    constructor(public dialog: MatDialog,
        private sessionStorageService: SessionStorageService,
        private activityService: ActivityService,
        private fileDownloadService: FileDownloadService) {
          this.title = "EXPORT DE L'ACTIVITE";
    }

    get AreDatesValid(): boolean {
        if (!_.isNil(this.fromFilterDate) && !_.isNil(this.toFilterDate)) {
            const from = moment(this.fromFilterDate);
            const to = moment(this.toFilterDate);
            return from.isSameOrBefore(to);
        }

        return true;
    }

    ngOnInit() {
        this.restoreFilters();
    }

    dateChangeSearch(result: any) {
      this.dateChange(result.type, result.selectedDate);
    }

    dateChange(type: string, selectedDate: any): void {
        var formated = !_.isNil(selectedDate) ? moment(selectedDate).format('YYYY-MM-DD') : null;

        switch (type) {
            case 'FromFilterDate':
                this.fromFilterDate = formated;
                break;
            case 'ToFilterDate':
                this.toFilterDate = formated;
                break;
        }
    }

    clearSearchFilter(): void {
        this.fromFilterDate = null;
        this.toFilterDate = null;
        this.storeFilters();
    }

    onExport(): void {
        const fromLabel = _.isNil(this.fromFilterDate) || _.isEmpty(this.fromFilterDate) ? 'début' : this.fromFilterDate;
        const toLabel = _.isNil(this.toFilterDate) || _.isEmpty(this.toFilterDate) ? 'maintenant' : this.toFilterDate;
        const fileName = `export_${fromLabel}-${toLabel}.xlsx`;
        this.activityService.getInvoicesActivity(this.fromFilterDate, this.toFilterDate)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((blobData: Blob) => {
                this.fileDownloadService.downloadBlob(blobData, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            }, (_) => {
                const modalErreurConfig = new ModalHelper().getAlertConfig(`Une erreur est survenue lors du téléchargement.`);
                this.dialog.open(ModalComponent, modalErreurConfig);
            })
    }

    private restoreFilters(): void {
        const searchFilter = this.sessionStorageService.get<SearchFilterModel<any>>(this.filterStorageKey);

        if (_.isNil(searchFilter)) {
            return;
        }

        this.fromFilterDate = searchFilter.Filter.fromFilterDate;
        this.toFilterDate = searchFilter.Filter.toFilterDate;
    }

    private storeFilters(): void {
        var filter = new SearchFilterModel();
        filter.Filter = { fromFilterDate: this.fromFilterDate, toFilterDate: this.toFilterDate };
        sessionStorage.setItem(this.filterStorageKey, JSON.stringify(filter));
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
    }
}
